<template>
  <div class="box noBtn" v-if="kbxmlc">
    <!-- 投标代理 -->
    <div class="clear">
      <p class="cont-title lf">多次报价</p>
      <div class="rt">
        <el-input
          v-model="tbdwmc"
          class="input-with-select lf"
          style="width: 250px; margin: 0 10px"
          placeholder="投标单位名称"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchData"
            :disabled="waitLoading"
          ></el-button>
        </el-input>
        <el-button type="primary" :disabled="waitLoading" @click="published"
          >公布报价</el-button
        >
      </div>
    </div>

    <el-table
      ref="table"
      border
      :data="tableData"
      style="width: 100%"
      max-height="570"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column type="index" label="序号" width="60"> </el-table-column>
      <el-table-column
        prop="qymc"
        label="投标单位名称"
        show-overflow-tooltip
        min-width="180"
      ></el-table-column>
      <el-table-column
        width="140"
        show-overflow-tooltip
        v-for="(item, index) in priceAry"
        :key="index"
        :label="item.bjcsmc"
      >
        <template slot-scope="scope">
          {{ scope.row.cgkbdcbjList[index].bjje }}
        </template>
      </el-table-column>
    </el-table>
    <div class="clear">
      <span class="lf pageNum">共{{ total }}家。</span>
    </div>
    <!-- 发布报价弹窗 -->
    <el-dialog
      title="公布报价"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="dialogBox" style="margin-top: 30px; text-align: center">
        <img src="../../assets/images/！.png" alt="" />
        <span class="pIcon">请确认是否公开历史报价</span>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="yesSubmit" :disabled="waitLoading"
          >是</el-button
        >
        <el-button
          type="primary"
          class="notBtn"
          @click="noSubmit"
          :disabled="waitLoading"
          >否</el-button
        >
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      waitLoading: false,
      dialogVisible: false,
      tbdwmc: "",
      tableData: [],
      priceAry: [],
      total: " ",
      kbxmlc: "",
      endCode: 0,
    };
  },
  created() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
  methods: {
    async getData() {
      let para = {
        djlcId: this.djlcId,
        endCode: this.endCode,
      };
      try {
        let res = await this.$api.dcbjquery(para);
        if (res.status == 200) {
          res.data.data.dcbj.forEach((ele, index) => {
            this.priceAry = [...ele.cgkbdcbjList];
          });
          this.total = res.data.data.total;
          this.tableData = res.data.data.dcbj;
          this.kbxmlc = res.data.data.kbxmlc;
        } else {
          this.$message({
            type: "error",
            message: res.data.meta.message,
          });
        }
      } catch (err) {
        console.log("招标人", err);
      }
    },
    async searchData() {
      this.waitLoading = true;
      let para = {
        qymc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      try {
        let res = await this.$api.querylike(para);
        if (res.status == 200) {
          let a = res.data.data.dcbj;
          if (this.tbdwmc) {
            a.forEach((ele, index) => {
              this.priceAry = [...ele.cgkbdcbjList];
            });
            this.total = 1;
            this.tableData = [a[length - 1]];
          } else {
            console.log(a);
            a.forEach((ele, index) => {
              this.priceAry = [...ele.cgkbdcbjList];
            });
            this.total = 1;
            this.tableData = a;
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.meta.message,
          });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log("开启报价", err);
        this.waitLoading = false;
      }
    },
    published() {
      this.dialogVisible = true;
    },
    yesSubmit() {
      this.waitLoading = true;
      this.setPublish(1);
    },
    noSubmit() {
      this.waitLoading = true;
      this.setPublish(2);
    },
    async setPublish(val) {
      let para = {};
      // 1是 2否
      para.publishZt = val;
      try {
        let res = await this.$api.overridepublish(para);
        if (res.status == 200) {
          if (val == 1) {
            this.$message({
              type: "success",
              message: "报价公布成功！",
            });
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.meta.message,
          });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log("开启报价", err);
        this.waitLoading = false;
      }
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang='scss' scoped>
.dialogBox {
  height: 70px;
  img {
    vertical-align: middle;
    margin-right: 15px;
  }
  span {
    font-size: 20px;
    color: #333333;
  }
}
.notBtn {
  color: #d70a30;
  border: 1px solid #d70a30 !important;
  background: transparent;
}
.notBtn:hover {
  opacity: 0.7;
}
</style>
